import _get from 'lodash/get';

export const getListByScreen = (listData, isMobile) =>
  isMobile
    ? _get(listData, 'results.mobileList', [])
    : _get(listData, 'results.list', []);
